import { Radio } from "atoms/radio/Radio";
import { Text } from "atoms/Text/Text";

export interface RetailProductOrderReturnLineItemCardProps {
  thumbnailImageUri?: string;
  name: string;
  packageId: string;
  isSelected?: boolean;
  hideRadio?: boolean;
  disabled?: boolean;
  disabledMessage?: string;
  onSelect?: (packageId: string) => void;
}

export const RetailProductOrderReturnLineItemCard = ({
  thumbnailImageUri,
  name,
  packageId,
  isSelected,
  onSelect,
  hideRadio = false,
  disabled = false,
  disabledMessage,
}: RetailProductOrderReturnLineItemCardProps) => {
  const handleClick = () => {
    if (!disabled) {
      onSelect?.(packageId);
    }
  };

  const getSelectedStyle = () => {
    if (disabled) {
      return "border-gray-200 bg-gray-50 opacity-60";
    }
    return isSelected ? "bg-brand-tint" : "border-gray-300 bg-white";
  };

  return (
    <button
      className={`flex h-[102px] rounded-lg p-2 ${getSelectedStyle()}`}
      onClick={handleClick}
      disabled={disabled}
    >
      <div className="flex flex-row items-center gap-4">
        {!hideRadio && (
          <div className="flex items-center">
            <Radio
              checked={isSelected}
              onChange={() => onSelect?.(packageId)}
              name="returnItem"
              disabled={disabled}
            />
          </div>
        )}
        <div className="relative">
          {thumbnailImageUri && (
            <img
              src={thumbnailImageUri}
              alt={name}
              className="h-[86px] w-[86px] rounded-lg border object-cover"
            />
          )}
        </div>
        <div className="flex flex-1 flex-col text-left">
          <Text variant="body2">{name}</Text>
          {disabled && disabledMessage && (
            <Text variant="body3" className="mt-1 text-gray-500">
              {disabledMessage}
            </Text>
          )}
        </div>
      </div>
    </button>
  );
};
